import { observer } from 'mobx-react';
import React from 'react';

interface Props {
  caseView: boolean;
  onToggle: () => void;
}

const ViewToggler = observer(({caseView, onToggle}: Props) => {

  const clickRadio = (e: React.FormEvent<HTMLDivElement>) => {
    const inputs = e.currentTarget.getElementsByTagName('input')
    if (inputs[0].checked) {
      inputs[1].click();
    } else {
      inputs[0].click();
    }
  };

  return (
    <div className='view-switcher'
      onMouseDown={clickRadio}
      role="radiogroup"
      aria-label='View mode'
    >
      <input
        type="radio"
        value='customer-view'
        aria-labelledby='customer-view-label'
        checked={!caseView}
        onChange={onToggle}
      />
      <div className={caseView ? '' : 'active'}>
        <span id='customer-view-label'>Customer View</span>
      </div>

      <input
        type="radio"
        value='case-view'
        aria-labelledby='case-view-label'
        checked={caseView}
        onChange={onToggle}
      />
      <div className={caseView ? 'active' : ''}>
        <span id='case-view-label'>Case View</span>
      </div>
    </div>
  );
});

export default ViewToggler;
